module.exports = __webpack_public_path__ + "img/6.6ab59b66.png";